__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "container";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.14.0", () => (Promise.all([__webpack_require__.e(655), __webpack_require__.e(532), __webpack_require__.e(777)]).then(() => (() => (__webpack_require__(4158))))));
			register("@emotion/styled", "11.14.0", () => (Promise.all([__webpack_require__.e(532), __webpack_require__.e(239), __webpack_require__.e(860)]).then(() => (() => (__webpack_require__(1479))))));
			register("@fontsource-variable/inter", "5.2.5", () => (Promise.all([__webpack_require__.e(537), __webpack_require__.e(936)]).then(() => (() => (__webpack_require__(537))))));
			register("@mui/material", "5.17.1", () => (Promise.all([__webpack_require__.e(655), __webpack_require__.e(967), __webpack_require__.e(671), __webpack_require__.e(532), __webpack_require__.e(90), __webpack_require__.e(239), __webpack_require__.e(132)]).then(() => (() => (__webpack_require__(2967))))));
			register("@sentry/react", "9.23.0", () => (Promise.all([__webpack_require__.e(135), __webpack_require__.e(532)]).then(() => (() => (__webpack_require__(6135))))));
			register("@tanstack/react-query", "5.67.1", () => (Promise.all([__webpack_require__.e(114), __webpack_require__.e(532), __webpack_require__.e(848)]).then(() => (() => (__webpack_require__(6114))))));
			register("cliengo-fe-utils", "1.0.7", () => (__webpack_require__.e(955).then(() => (() => (__webpack_require__(1955))))));
			register("i18next", "23.16.8", () => (__webpack_require__.e(635).then(() => (() => (__webpack_require__(2635))))));
			register("js-cookie", "2.2.1", () => (__webpack_require__.e(210).then(() => (() => (__webpack_require__(1210))))));
			register("js-cookie", "3.0.5", () => (__webpack_require__.e(987).then(() => (() => (__webpack_require__(8987))))));
			register("launchdarkly-js-client-sdk", "3.5.0", () => (__webpack_require__.e(440).then(() => (() => (__webpack_require__(4440))))));
			register("launchdarkly-js-client-sdk", "3.8.0", () => (__webpack_require__.e(898).then(() => (() => (__webpack_require__(9898))))));
			register("prop-types", "15.8.1", () => (__webpack_require__.e(556).then(() => (() => (__webpack_require__(5556))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(532)]).then(() => (() => (__webpack_require__(961))))));
			register("react-i18next", "13.5.0", () => (Promise.all([__webpack_require__.e(532), __webpack_require__.e(770)]).then(() => (() => (__webpack_require__(2389))))));
			register("react-onesignal", "3.2.2", () => (__webpack_require__.e(189).then(() => (() => (__webpack_require__(7189))))));
			register("react-router-dom", "6.25.1", () => (Promise.all([__webpack_require__.e(260), __webpack_require__.e(532), __webpack_require__.e(90)]).then(() => (() => (__webpack_require__(3260))))));
			register("react-router-dom", "6.30.1", () => (Promise.all([__webpack_require__.e(411), __webpack_require__.e(532), __webpack_require__.e(90)]).then(() => (() => (__webpack_require__(792))))));
			register("react-use", "17.6.0", () => (Promise.all([__webpack_require__.e(380), __webpack_require__.e(532), __webpack_require__.e(704)]).then(() => (() => (__webpack_require__(2380))))));
			register("react", "18.3.1", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(6540))))));
			initExternal(4856);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};